module.exports = __webpack_public_path__ + "media/images/emblems/Courtelary-coat_of_arms-047581f06a383e3fb1e6e72bb9aa7db7.svg";